import PropTypes from 'prop-types';
import React from 'react';
import Dialog from 'components/Molecules/Dialog';

const DeleteEmployee = ({
  handleComment,
  handleCancel,
  secondaryBtn,
  primaryBtn,
  primaryBtnColor,
  open,
  handleClose,
  title,
  desc,
}) => {
  return (
    <Dialog
      open={open}
      handleClose={handleClose}
      dialogTitle={title}
      dialogDesc={desc}
      secondaryBtn={secondaryBtn}
      primaryBtn={primaryBtn}
      handlePrimaryBtn={handleComment}
      handleSecondaryBtn={handleCancel}
      primaryBtnColor={primaryBtnColor}
      bodyContent={false}
    />
  );
};
DeleteEmployee.defaultProps = {
  primaryBtnColor: 'error',
  secondaryBtn: 'Cancel',
  primaryBtn: 'DeActivate',
  handleComment: () => {},
  handleCancel: () => {},
  open: true,
  handleClose: () => {},
  title: 'Dialog Title',
  desc: 'Dailog Desc',
};
DeleteEmployee.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  primaryBtnColor: PropTypes.string,
  handleComment: PropTypes.func,
  handleCancel: PropTypes.func,
  secondaryBtn: PropTypes.string,
  primaryBtn: PropTypes.string,
  title: PropTypes.string,
  desc: PropTypes.string,
};
export default DeleteEmployee;
